namespace Matrix.Dashboards {

    export interface MatrixBlogWidgetOptions extends IWidgetOptions {
    }

    @Serenity.Decorators.registerClass('Matrix.Dashboards.MatrixBlogWidget')
    export class MatrixBlogWidget extends Serenity.Widget<MatrixBlogWidgetOptions> {

        private data: Data.BlogPost[];

        constructor(element: JQuery, opt: any) {
            super(element, opt);

            this.refresh();
        }

        protected refresh() {

            Data.BlogService.GetPosts({
            },
                (response) => {
                    this.data = response.Entities || [];
                    this.updateContent();
                }, {
                    onError: response => {
                        this.displayError(response?.Error?.Message);
                    }
            });
        }
        
        displayError(message: string) {
            if (message && this.options.__designer)
                Q.notifyError(message);
            this.element.html('<div class="dash-widget-broken"><i class="fa fa-bug"></i></div>')
                .children().attr('title', message);
        }

        protected updateContent(): void {
            this.element.html('');

            if (!this.data)
                return;

            this.element.html(this.data.map(post =>
                `<div class="blog-post">
    <h4>${Q.htmlEncode(post.Title)}</h4>
    <p class="mb-0">${Q.htmlEncode(post.Excerpt)}</p>
    <a href="${Q.attrEncode(post.Uri)}" target="_blank" class="pull-right read-more">Read more</a>
    <div class="clear"></div>
</div>`).join('\n'));
        }

    }

}